module.exports = __webpack_public_path__ + "img/home_type_french.15c5eb38.webp";